import { useContext, useEffect } from 'react';

import { Flex, FloraButton } from '@grupoboticario/flora-react';
import { NotebookIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { DRAWERS, QUERYPARAMS } from 'config/environments/shared';
import { getPaymentStatus } from 'helpers';
import { usePaymentDetail, useDrawer, useTracking } from 'hooks';
import { GlobalContext } from 'store';

export const RenegotiationPortal = () => {
  const { brand } = useContext(GlobalContext);
  const { searchParams } = useDrawer(DRAWERS.RENEGOTIATION);
  const { data, trigger } = usePaymentDetail(searchParams.get(QUERYPARAMS.PAYMENT_ID) || '');
  const { sendDataToGTM } = useTracking();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(trigger, []);

  const handleOnClick = () => {
    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'interaction_renegociar_pagamento',
        cd_interaction_detail: 'click:acessar-o-portal',
        transaction_id: data?.paymentTitleId,
        cd_metodo_pagamento: data?.planDetail.toLowerCase(),
        cd_status_pagamento:
          data &&
          getPaymentStatus({
            daysLate: data?.daysLate,
            daysUntilDueDate: data?.daysUntilDueDate,
            paymentStatus: data?.paymentStatus,
            status: data?.status,
          })?.tag.toLowerCase(),
        cd_dias_para_vencimento: data?.daysUntilDueDate,
        cd_dias_apos_vencimento: data?.daysLate,
      },
    });
  };
  return (
    <Flex direction='column' gap='$4'>
      <Flex justify='flex-start' gap='$2' align='center'>
        <NotebookIcon />
        <ResponsiveFloraTypography fontSize='bodySmallStandard'>
          Portal de Renegociação
        </ResponsiveFloraTypography>
      </Flex>
      <Flex direction='column' gap='$2'>
        <ResponsiveFloraTypography fontSize='bodySmallStandard'>
          {brand.sac.portalName}
        </ResponsiveFloraTypography>
        <ResponsiveFloraTypography fontSize='bodySmallStandard'>
          {brand.sac.hours.portal}
        </ResponsiveFloraTypography>
      </Flex>
      <FloraButton
        as={Link}
        isFull
        has='iconLeft'
        icon={<NotebookIcon />}
        onClick={handleOnClick}
        rel='noopener noreferrer'
        target='_blank'
        hierarchy='primary'
        to={brand.sac.portalLink}
      >
        <ResponsiveFloraTypography fontWeight='bold'>Acessar o portal</ResponsiveFloraTypography>
      </FloraButton>
    </Flex>
  );
};
